import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppStore } from '../../store/applicationState';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import { StylesTable } from '../Stylestable';
import Pagination from '@mui/material/Pagination';
import TextField from '@mui/material/TextField';
import { IProduct } from '../../store/products/types';
import { EnhancedTableHead } from '../ui';
import { Order, stableSort } from '../../utils/stableSort';
import { GetBookmarks, GetBookmarksCsv } from '../../store/bookmarks/actions';
import Button from '@mui/material/Button';
import { BasicDatePicker, SelectOutline, SelectSearchReq } from '../ui';
import { IDataOpt } from '../ui/SelectSearchReq';
import { useSearchProducts } from '../../hooks/useSearchProducts';
import CircularProgress from '@mui/material/CircularProgress';

interface Column {
  id: 'user_id' | 'email' | 'site' | 'title' | 'url' | 'date_create' | 'last_view_cabinet' |
  'count_click_cabinet' | 'count_click_widget' | 'last_view_widget' | 'date_delete';
  label: string;
  sort?: boolean;
  align?: 'right' | 'left' | 'center';
  width?: string;
  roles?: number[];
}

const sort = true;
const columns: Column[] = [
  { id: 'user_id', label: 'userid', align: 'center', sort, width: '10%' },
  { id: 'email', label: 'Email', align: 'center', sort, width: '10%' },
  { id: 'site', label: 'Назва продукта', align: 'center', sort, width: '10%' },
  { id: 'title', label: 'Назва матеріалу', align: 'center', sort, width: '10%' },
  { id: 'url', label: 'Url матеріалу', align: 'center', sort, width: '10%' },
  { id: 'date_create', label: 'Дата додавання', align: 'center', sort, width: '10%' },
  { id: 'last_view_cabinet', label: 'Дата останнього кліку в кабінеті', align: 'center', sort, width: '10%' },
  { id: 'count_click_cabinet', label: 'Кількість кліків у кабінеті', align: 'center', sort, width: '7%' },
  { id: 'count_click_widget', label: 'Дата останнього кліку у віджеті', align: 'center', sort, width: '7%' },
  { id: 'last_view_widget', label: 'Кількість кліків у віджеті', align: 'center', sort, width: '7%' },
  { id: 'date_delete', label: 'Дата видалення', align: 'center', sort, width: '7%' },

];

type PropsType = {};

const initialFilters = {
  user_id: '',
  email: '',
  url: '',
  dateStart: null as Date | null,
  dateEnd: null as Date | null,
  productMain: null as IDataOpt | null,
  productId: '',
  typeSubscribe: '3',
};


export const ListBookmarks: React.FC<PropsType> = () => {
  const [tempFilters, setTempFilters] = useState(initialFilters);
  const [appliedFilters, setAppliedFilters] = useState(initialFilters);

  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof IProduct>('absnum');
  const [page, setPage] = React.useState(1);

  const { Bookmarks } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();
  const classesTable = StylesTable();
  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof IProduct) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const { subOptions, mainOptions, selectedMainProduct, handleSearch: handleSearchProduct } = useSearchProducts();

  const performSearch = () => {
    const emailToPass = tempFilters.email.length >= 3 ? tempFilters.email : '';

    dispatch(
      GetBookmarks.request({
        data: {
          ...tempFilters,
          email: emailToPass,
          productMainId: tempFilters.productMain ? String(tempFilters.productMain.id) : '',
        },
      })
    );
  };

  const handleSearch = () => {
    setAppliedFilters({ ...tempFilters })
    performSearch();
  };

  useEffect(() => {
    performSearch();
  }, []);

  const handleChangePage = (event: unknown, newPage: number) => {
    if (!Bookmarks.data) return;

    if (Bookmarks.data.pages >= newPage) {
      setPage(newPage);

      dispatch(
        GetBookmarks.request({
          data: {
            ...appliedFilters,
            page: newPage,
            productMainId: appliedFilters.productMain
              ? String(appliedFilters.productMain.id)
              : '',
          },
        })
      );
    }
  };

  const clearFilters = () => {
    setTempFilters(initialFilters)
    setAppliedFilters(initialFilters)
    dispatch(GetBookmarks.request({ data: {} }));
  };


  const exportFile = () => {
    dispatch(
      GetBookmarksCsv.request({
        data: {
          ...appliedFilters,
          productMainId: appliedFilters.productMain ? String(appliedFilters.productMain.id) : '',
        },
      })
    );
  };

  if (Bookmarks.loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <CircularProgress color="secondary" />
  </div>;

  const productVersionTooltipText = !subOptions.length
    ? tempFilters.productMain
      ? 'У продукту немає версій'
      : 'Спершу оберіть головний продукт'
    : '';

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '89vh',
        overflow: 'hidden',
      }}
    >
      <Box style={{ display: 'flex', flexWrap: 'wrap', marginTop: '5px'  }}>
        <TextField
          style={{ marginRight: '10px' }}
          size="small"
          id="outlined-basic-id"
          label="ID користувача"
          variant="outlined"
          value={tempFilters.user_id}
          className={classesTable.searchField}
          onChange={(e) => {
            setTempFilters((prev) => ({ ...prev, user_id: e.target.value }));
          }}
        />
        <TextField
          style={{ marginRight: '10px' }}
          size="small"
          id="outlined-basic-id"
          label="Email (від 3х символів)"
          variant="outlined"
          value={tempFilters.email}
          className={classesTable.searchField}
          onChange={(e) => {
            setTempFilters((prev) => ({ ...prev, email: e.target.value }));
          }}
        />
        <TextField
          style={{ marginRight: '10px' }}
          size="small"
          id="outlined-basic-id"
          label="Назва (url) матеріалу"
          variant="outlined"
          value={tempFilters.url}
          className={classesTable.searchField}
          onChange={(e) => {
            setTempFilters((prev) => ({ ...prev, url: e.target.value }));
          }}
        />
        <div className={classesTable.searchField} style={{ width: '210px' }}>
          <BasicDatePicker
            id="dateStart"
            label="Дата старту"
            value={tempFilters.dateStart}
            onChange={(date) => setTempFilters((prev) => ({ ...prev, dateStart: date }))}
          />
        </div>
        <div className={classesTable.searchField} style={{ width: '210px' }}>
          <BasicDatePicker
            id="dateEnd"
            label="Дата закінчення"
            value={tempFilters.dateEnd}
            onChange={(date) => setTempFilters((prev) => ({ ...prev, dateEnd: date }))}
          />
        </div>
        <SelectSearchReq
          data={tempFilters.productMain}
          style={{ marginRight: '10px', width: '210px' }}
          title="Головний продукт"
          className={classesTable.searchField}
          onChange={(data) => {
            selectedMainProduct(data);
            setTempFilters((prev) => ({ ...prev, productId: '', productMain: data }));
          }}
          options={mainOptions}
          handleRequest={handleSearchProduct}
        />
        <SelectOutline
          style={{ marginRight: '10px', width: '210px' }}
          id="outlined-basic"
          title="Версія продукту"
          value={tempFilters.productId}
          className={classesTable.searchField}
          options={subOptions}
          handleChange={(value) => setTempFilters((prev) => ({ ...prev, productId: value }))}
          disabled={!subOptions.length}
          tooltipText={productVersionTooltipText}
        />
        <SelectOutline
          style={{ width: '210px' }}
          className={classesTable.searchField}
          title="Тип підписки"
          options={[
            { value: '3', label: 'Усі' },
            { value: '1', label: 'Демодоступ' },
            { value: '0', label: 'Підписники' },
          ]}
          handleChange={(value) => setTempFilters((prev) => ({ ...prev, typeSubscribe: value }))}
          value={tempFilters.typeSubscribe}
        />
        <Button variant="contained" color="primary" onClick={clearFilters} style={{ height: '40px' }}>
          Очистити фільтри
        </Button>
        <Button disabled={Bookmarks.loadingCsv} variant="contained" color="primary" onClick={exportFile} style={{ height: '40px', marginLeft: '10px' }}>
          {Bookmarks.loadingCsv ? <><span style={{ marginRight: '10px' }}>Завантаження </span><CircularProgress size={25} /></> : 'Вивантажити у CSV'}
        </Button>
        <Button variant="contained" color="primary" onClick={handleSearch} style={{ height: '40px', marginLeft: '10px' }}>
          Пошук
        </Button>
      </Box>
      <TableContainer
        className={classesTable.container}
        style={{
          marginBottom: "40px",
          overflow: 'auto',
        }}
      >
        <Table className={classesTable.table} stickyHeader aria-label="sticky table">
          <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} columns={columns} />
          <TableBody>
            {Bookmarks && Bookmarks.data &&
              stableSort(Bookmarks.data.bookmarks, order, orderBy).map((row, i) => {
                return (
                  <TableRow style={{ maxHeight: 50 }} hover role="checkbox" tabIndex={-1} key={`${i}-${row.user_id}`}>
                    <TableCell align="center" style={{ overflowWrap: 'break-word' }}>
                      {row.user_id}
                    </TableCell>
                    <TableCell align="center" style={{ overflowWrap: 'break-word' }}>
                      {row.email}
                    </TableCell>
                    <TableCell align="center" style={{ overflowWrap: 'break-word' }}>
                      {row.site}
                    </TableCell>
                    <TableCell align="center" style={{ overflowWrap: 'break-word' }} >
                      {row.title}
                    </TableCell>
                    <TableCell align="center" style={{ overflowWrap: 'break-word' }} >
                      {row.url}
                    </TableCell>
                    <TableCell align="center" style={{ overflowWrap: 'break-word' }}>
                      {row.date_create}
                    </TableCell>
                    <TableCell align="center" style={{ overflowWrap: 'break-word' }}>
                      {row.last_view_cabinet}
                    </TableCell>
                    <TableCell align="center" style={{ overflowWrap: 'break-word' }}>
                      {row.count_click_cabinet}
                    </TableCell>
                    <TableCell align="center" style={{ overflowWrap: 'break-word' }}>
                      {row.last_view_widget}
                    </TableCell>
                    <TableCell align="center" style={{ overflowWrap: 'break-word' }}>
                      {row.count_click_widget}
                    </TableCell>
                    <TableCell align="center" style={{ overflowWrap: 'break-word' }}>
                      {row.date_delete}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        style={{
          flexShrink: 0,
          padding: "10px 0px",
          background: " rgb(255, 255, 255)"
        }}
      >
        <Pagination
          className={classesTable.pagination}
          count={Bookmarks && Bookmarks.data ? Bookmarks.data.pages : 0}
          page={page}
          onChange={handleChangePage}
          style={{
            width: "100%",
            bottom: "2vh",
            right: 0,
            flexShrink: 0,
            padding: "10px 0px",
            position: "absolute",
            marginRight: "0vw",
          }}
        />
      </Box>
    </Box>
  );
};
